@if (label !== null) {
	<label class="form-label" [class.required]="isRequired" [class.invalid]="isInvalid" [class.d-block]="headerLabelDisplayBlock">{{ label }}</label>
}
<div
	ngbDropdown
	class="flex-fill pseudo-form-control"
	#ngbDropdown="ngbDropdown"
	[class.disabled]="disabled"
	[autoClose]="insideClick"
	(openChange)="openChanged($event)"
	(keydown)="textTyped($event)">
	<a ngbDropdownToggle [ngClass]="dropdownToggleClasses" href="javascript:void(0)" role="button" aria-haspopup="true" aria-expanded="false">
		<span class="dropdown-toggle-text-container" [attr.alt]="dropdownToggleText">
			<ng-container [ngTemplateOutlet]="nameTemplate" [ngTemplateOutletContext]="{ $implicit: option }"></ng-container>
			@if (dropdownToggleText) {
				<span [innerHTML]="dropdownToggleText"></span>
			}
			@if (!nameTemplate && option !== null && !templateOnlyMenu && !dropdownToggleText) {
				<ng-container [ngTemplateOutlet]="rowRef" [ngTemplateOutletContext]="{ $implicit: option }"> </ng-container>
			}
		</span>
	</a>
	<div ngbDropdownMenu class="scroll-dropdown" [ngClass]="dropdownMenuClasses">
		<div #scrollingArea class="row scrolling-area" [ngClass]="dropdownMenuRowClasses">
			<div class="col container-column">
				@if (nullOptionSelectable && nullOption) {
					<a (click)="onSelect(null, $event)" [class.selected-item]="option === null" href="javascript:void(0)" class="dropdown-item">
						{{ nullOption }}
					</a>
				}
				@for (rowOption of visibleOptions; track rowOption) {
					<a
						(click)="onSelect(rowOption, $event)"
						class="dropdown-item"
						#optionsRef
						[class.selected-item]="rowOption === option"
						href="javascript:void(0)">
						@if (!rowRef) {
							<span [innerHTML]="boldMap(textMap(rowOption))"></span>
						}
						<ng-container [ngTemplateOutlet]="rowRef" [ngTemplateOutletContext]="{ $implicit: rowOption }"></ng-container>
					</a>
				}
			</div>
		</div>
	</div>
</div>
